/**
 * Get market prices
 */
import type { Address } from "viem"
import { type ReadableClient, readPrices } from "../../internal/contracts"
import { fromPriceScaleArray } from "../../internal/convert"

export interface GetPricesParams {
	market: Address
}

/**
 * Get current prices for all buckets in a market
 *
 * @returns Array of prices in 0-1 range (e.g., 0.45 = 45%)
 *
 * @example
 * ```ts
 * import { getPrices } from "@breakout/sdk/actions/read"
 *
 * const prices = await getPrices(publicClient, { market: "0x..." })
 * console.log(prices) // [0.45, 0.55] for a binary market
 * ```
 */
export async function getPrices(
	client: ReadableClient,
	params: GetPricesParams,
): Promise<number[]> {
	const rawPrices = await readPrices(client, params.market)
	return fromPriceScaleArray(rawPrices)
}
